module.exports = __webpack_public_path__ + "img/hnjt2.2d2084e2.jpg";